import {
    Component,
    HostBinding,
    Input,
    TemplateRef,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { InfoComponent } from "../info/info.component";

@Component({
    selector: "rask-textmultiline",
    templateUrl: "./textmultiline.component.html",
    styleUrls: ["./textmultiline.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        InfoComponent,
        NgTemplateOutlet
    ]
})
export class TextmultilineComponent {
    @Input() label = "";
    @Input() value: string;
    @Input() values: string[] = [];
    @Input() aid: string;
    @Input() iconClass = "";
    @Input() tightLabel = false;
    @Input() ultraTightLabel = false;
    @Input() boldText = false;
    @Input() nullIndicator = false;
    @Input() infoText?: string;
    @Input() infoTemplate: TemplateRef<any>;
    @Input() wrapLabel = false;
    @HostBinding("class.height-initial") get abc() { return this.values?.length > 0; }
}
